import { сontragentTypeValues } from './common.ts';

export const applicationStatus = [
  { value: '0', label: 'Нова' },
  { value: '1', label: 'Готова до відправки' },
  { value: '2', label: 'В обробці банком' },
  { value: '3', label: 'На доопрацюванні' },
  { value: '4', label: 'Узгоджена' },
  { value: '5', label: 'Відхилена' },
  { value: '6', label: 'Закрита' },
  { value: '7', label: 'Видалено в архів' },
];

export enum APPLICATION_STATUS {
  MOVED_TO_ARCHIVE = 'Видалено в архів',
  NEW = 'Нова',
}

export const contragentType = [
  сontragentTypeValues.CONTRAGENT_LEGAL_RESIDENT,
  сontragentTypeValues.CONTRAGENT_SOLE_TRADER,
];

export const clientApplicationType = [
  { value: 'PRIMARY', label: 'Первинна' },
  { value: 'RE_IDENTIFICATION', label: 'Повторна' },
];

export const initiatorTypeList = [
  { value: '1', label: 'Клієнт' },
  { value: '2', label: 'Менеджер' },
];

export const contrAgentType = [
  { value: 'INDIVIDUAL', label: 'Фізична особа / ФОП' },
  { value: 'REPRESENTATIVE', label: 'Представник клієнта' },
];

export const contrAgentTypeList = {
  SOLE_TRADER: contrAgentType[0]?.label,
  LEGAL_RESIDENT: contrAgentType[1]?.label,
  CONTR_AGENT_TYPE: 'Дані по клієнту відсутні',
};
